import { Stack, Typography } from "@mui/material";
import MetricValueCard from ".";
import { WellnessScoreStatus } from "../types";
import IconLoader from "@/features/Common/components/IconLoader";

export default function MetricValueCardExamples() {
  return (
    <Stack gap={3} width="100%">
      <MetricValueCard
        metricName="Current BP"
        metricValue="127 / 76"
        unit="mmHg"
        status={WellnessScoreStatus.NeedsAttention}
        lastUpdated="2025-02-23T00:00:00Z"
        ctaText="Update blood pressure"
        onCtaClick={() => console.log("CTA clicked")}
      >
        <Stack
          sx={{
            backgroundColor: "secondary.100",
            borderRadius: 2,
            p: 2,
          }}
          flexDirection="row"
          gap={1.5}
        >
          <IconLoader icon="FlagIcon" color="secondary" />
          <Typography
            sx={{
              fontSize: 14,
              lineHeight: 1.5,
              color: "neutral.700",
            }}
          >
            Your blood pressure is higher than expected. It may help to keep an
            eye on it and check again soon.
          </Typography>
        </Stack>
      </MetricValueCard>

      <MetricValueCard
        metricName="Current heart rate"
        metricValue="72"
        unit="bpm"
        status={WellnessScoreStatus.Healthy}
        lastUpdated="2025-02-20T00:00:00Z"
        ctaText="Update heart rate"
        onCtaClick={() => console.log("CTA clicked")}
      />

      <MetricValueCard
        metricName=" Current breathing rate"
        metricValue="180"
        unit="mg/dL"
        status={WellnessScoreStatus.NeedsSupport}
        lastUpdated="2025-02-18T00:00:00Z"
        ctaText="Update breathing rate"
        onCtaClick={() => console.log("CTA clicked")}
      >
        <Stack
          sx={{
            backgroundColor: "error.light",
            borderRadius: 2,
            p: 2,
          }}
          flexDirection="row"
          gap={1.5}
        >
          <IconLoader icon="FlagIcon" color="error" />
          <Typography
            sx={{
              fontSize: 14,
              lineHeight: 1.5,
              color: "neutral.700",
            }}
          >
            Your breathing rate is well above normal, suggesting your body is
            working much harder than usual.
          </Typography>
        </Stack>
      </MetricValueCard>
    </Stack>
  );
}
